var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoardCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 0C49.7025 0 60 10.2975 60 23V37C60 49.7025 49.7025 60 37 60H23C10.2975 60 0 49.7025 0 37V23C0 10.2975 10.2975 0 23 0H37Z",
    fill: "#E8E8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3334 19.3333C36.5733 19.3333 37.1933 19.3333 37.702 19.4696C39.0824 19.8395 40.1605 20.9176 40.5304 22.298C40.6667 22.8067 40.6667 23.4267 40.6667 24.6666V36.9333C40.6667 39.1735 40.6667 40.2936 40.2307 41.1493C39.8472 41.9019 39.2353 42.5138 38.4827 42.8973C37.627 43.3333 36.5069 43.3333 34.2667 43.3333H25.7334C23.4932 43.3333 22.3731 43.3333 21.5174 42.8973C20.7648 42.5138 20.1528 41.9019 19.7693 41.1493C19.3334 40.2936 19.3334 39.1735 19.3334 36.9333V24.6666C19.3334 23.4267 19.3334 22.8067 19.4697 22.298C19.8395 20.9176 20.9177 19.8395 22.2981 19.4696C22.8068 19.3333 23.4267 19.3333 24.6667 19.3333M26 34L28.6667 36.6666L34.6667 30.6666M26.8 22H33.2C33.9468 22 34.3201 22 34.6054 21.8546C34.8562 21.7268 35.0602 21.5228 35.188 21.2719C35.3334 20.9867 35.3334 20.6134 35.3334 19.8666V18.8C35.3334 18.0532 35.3334 17.6799 35.188 17.3946C35.0602 17.1438 34.8562 16.9398 34.6054 16.812C34.3201 16.6666 33.9468 16.6666 33.2 16.6666H26.8C26.0533 16.6666 25.6799 16.6666 25.3947 16.812C25.1438 16.9398 24.9399 17.1438 24.812 17.3946C24.6667 17.6799 24.6667 18.0532 24.6667 18.8V19.8666C24.6667 20.6134 24.6667 20.9867 24.812 21.2719C24.9399 21.5228 25.1438 21.7268 25.3947 21.8546C25.6799 22 26.0533 22 26.8 22Z",
    stroke: "#7470E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardCheckCircle);
export default __webpack_public_path__ + "static/media/board-check-circle.c29f60db8e77a35032862ee3c8f4f9ee.svg";
export { ForwardRef as ReactComponent };